import React, { useEffect, useState } from "react";
import { Table, Typography, Tag, Alert, Card, Row, Col } from "antd";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { format, parseISO } from "date-fns";
import "../../styles/global-ui.css";
import BinMovementService from "../../services/BinMovementService";


const { Title, Text } = Typography;

const BinMovementTable = () => {
  const [binData, setBinData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const binId = queryParams.get("binId");

  // const fetchBinMovementData = async () => {
  //   setLoading(true);
  //   setError(null);

  //   try {
  //     const response = await axios.get(
  //       `https://unit47.smartekanban.in/index.php/Apiv4/getBinMovement/${binId}`
  //     );

  //     const { data, total_records } = response.data;

  //     if (!data || data.length === 0) {
  //       setError("No movement data found for this bin");
  //       setBinData([]);
  //       return;
  //     }

  //     const formattedData = data.map((item) => ({
  //       ...item,
  //       bin_from: formatBinName(item.bin_from),
  //       bin_to: formatBinName(item.bin_to),
  //     }));

  //     const sortedData = formattedData.sort(
  //       (a, b) => new Date(b.received_on) - new Date(a.received_on)
  //     );

  //     setBinData(sortedData);
  //     setTotalRecords(total_records);
  //   } catch (error) {
  //     console.error("Error fetching bin movement data:", error);
  //     setError("Failed to fetch bin movement data");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const fetchBinMovementData = async () => {
  setLoading(true);
  setError(null);

  try {
    const response = await BinMovementService.getBinMovement(binId);

    if (!response?.status || !response?.data?.length) {
      setError(response?.message || "No movement data found for this bin");
      setBinData([]);
      return;
    }

    const formattedData = response.data.map((item) => ({
      ...item,
      bin_from: formatBinName(item.bin_from),
      bin_to: formatBinName(item.bin_to),
    }));

    const sortedData = formattedData.sort(
      (a, b) => new Date(b.received_on) - new Date(a.received_on)
    );

    setBinData(sortedData);
    setTotalRecords(response.total_records || 0);
  } catch (error) {
    console.error("Error fetching bin movement data:", error);
    setError("Failed to fetch bin movement data");
  } finally {
    setLoading(false);
  }
};
  const formatBinName = (name) => {
    const map = {
      garment_super_market: "Garment Super Market",
      washing: "Washing",
      dispatch_center: "Transit Centre",
    };
    return map[name] || name || "-";
  };

  useEffect(() => {
    if (binId) {
      fetchBinMovementData();
    } else {
      setError("No Bin ID provided");
    }
  }, [binId]);

  const columns = [
    {
      title: "From",
      dataIndex: "bin_from",
      align: "center",
    },
    {
      title: "To",
      dataIndex: "bin_to",
      align: "center",
    },
    {
      title: "Sent By",
      dataIndex: "added_by",
      align: "center",
    },
    {
      title: "Sent On",
      dataIndex: "added_on",
      align: "center",
      render: (text) =>
        text ? format(parseISO(text), "dd-MMM-yyyy hh:mm a") : "-",
    },
    {
      title: "Received By",
      dataIndex: "received_by",
      align: "center",
    },
    {
      title: "Received On",
      dataIndex: "received_on",
      align: "center",
      render: (text) =>
        text ? format(parseISO(text), "dd-MMM-yyyy hh:mm a") : "-",
    },
    {
      title: "Status",
      dataIndex: "movement_status",
      align: "center",
      render: (text) => (
        <Tag
          color={
            text === "Received"
              ? "green"
              : text === "In Transit"
              ? "gold"
              : "red"
          }
        >
          {text || "-"}
        </Tag>
      ),
    },
  ];

  return (
    <div className="page-container">
      {/* HEADER */}
      <div className="page-header">
        <div className="page-title-wrap">
          <Title level={3} className="page-title">
            Bin Movement History
          </Title>
          <Text className="page-subtitle">
            Track movement history for Bin ID: {binId || "N/A"}
          </Text>
        </div>
      </div>

      {/* STATS */}
      <div className="compact-stats" style={{ marginBottom: 20 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={12} sm={8}>
            <div className="compact-stat-item">
              <div className="compact-stat-value">{totalRecords}</div>
              <div className="compact-stat-label">Total Records</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* ERROR */}
      {error && (
        <Card className="modern-card" style={{ marginBottom: 20 }}>
          <Alert message={error} type="error" showIcon />
        </Card>
      )}

      {/* TABLE */}
      <Card className="modern-card">
        <Table
          columns={columns}
          dataSource={binData}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize: 10,
            showSizeChanger: false,
            position: ["bottomRight"],
            showLessItems: true,
          }}
          scroll={{ x: 1000 }}
          className="premium-report-table"
        />
      </Card>
    </div>
  );
};

export default BinMovementTable;